import { Controller } from "stimulus";
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
  static targets = ['selectSwitch', 'action', 'selectedAmount'];

  connect() {
    this.form = this.element.querySelector('form');
    this.bindSelectSechedules();
    this.selectSwitchTarget.addEventListener('click', (ev) => {
      this.element.querySelector('#attendances-actions-selected').classList.toggle('hidden', !this.selectSwitchTarget.checked);

      if (this.selectSwitchTarget.checked)
        return this.prepareSchedulesToSelect();

      this.removeSelectionFromSchedules();
    });
  }

  bindSelectSechedules() {
    this.schedules.forEach((it) => {
      it.addEventListener('click', () => {
        let checkbox = it.querySelector('input[type="checkbox"]');
        !!checkbox && (checkbox.checked = !checkbox.checked);
        let _selectedAmount = this.selectedSchedules.length;
        this.selectedAmountTargets.forEach((it) => it.innerHTML = `(${_selectedAmount})`);
      });
    });
  }

  prepareSchedulesToSelect() {
    this.schedules.forEach((it) => {
      if (!!it._tippy)
        it._tippy.disable();

      it.insertAdjacentHTML('beforeend', `<input type="checkbox" value="${it.dataset.attendanceId}" name="attendances[]" class="select-attendances-checkbox" />`);
    });
  }

  removeSelectionFromSchedules() {
    this.schedules.forEach((it) => {
      if (!!it._tippy)
        it._tippy.enable();

      let checkbox = it.querySelector('input[type="checkbox"]');
      !!checkbox && checkbox.remove();
    });
  }

  removeAttendances() {
    this.submitForm('destroy', 'Deseja realmente remover <strong>permanentemente</strong> essas aulas?<br><br>Essa ação não poderá ser desfeita.');
  }

  cancelAttendances() {
    this.submitForm('cancel', 'Deseja realmente creditar essas aulas para os alunos?<br><br>Não será encaminhado nenhuma notificação para o aluno a respeito desse cancelamento.');
  }

  absentAttendances() {
    this.submitForm('absent', 'Deseja realmente marcar as aulas selecionadas como ausentes?');
  }

  presenceAttendances() {
    this.submitForm('presence', 'Deseja realmente marcar as aulas selecionadas como presença?');
  }

  submitForm(action, question) {
    if (this.selectedSchedules.length == 0)
      return sweet_alert.fire({ text: 'Nenhuma aula selecionada' });

    this.actionTarget.value = action;
    this.askQuestion(question).then(async (result) => {
			if (!result.value)
        return;

      AjaxLoader.show();
      this.form.insertAdjacentHTML('beforeend', '<button class="hidden" id="formSubmissionTrigger">submit</button>');
      setTimeout(() => this.form.querySelector('#formSubmissionTrigger').click());

      let turboFrame = this.form.closest('turbo-frame');
      await turboFrame.loaded;
      AjaxLoader.hide();
    });
  }

	askQuestion(question) {
		return sweet_alert.fire({
			title: 'Atenção',
			html: question,
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: 'Sim',
			cancelButtonText: 'Não',
		});
	}

  get schedules() {
    return this.element.querySelectorAll('span.badge[data-menu-badge]');
  }

  get selectedSchedules() {
    return this.element.querySelectorAll('span.badge[data-menu-badge] input[type="checkbox"]:checked');
  }
}